export enum ScheduleTypeEnum {
  student = 1,
  teacher = 2,
  school = 3,
  section = 4,
  occupancy = 5,
  subjects = 6
}
